import React from 'react';

export interface OperationInfoProps {
    label: string;
    children?: React.ReactNode;
}

export function OperationInfo({label, children}: OperationInfoProps) {
    return (
        <div className='flex flex-col gap-1'>
            <div className='fv-text-m-regular text-neutral-60'>{label}</div>
            <div className='fv-text-xl-regular text-neutral-100'>{children}</div>
        </div>
    );
}
